import {
  categoryUrl,
  chargersUrl,
  teamsUrl,
  userTypeUrl,
  userUrl,
  transactionsUrl,
  getTeamUrl,
  transactionIdUrl,
  meterValueUrl,
  tagsUrl,
  parentTagsUrl,
  tagsForRemoteOpUrl,
  availableTagsUrl,
  tagIdUrl,
  tagRollupUrl,
  tagChildrenUrl,
  tagParentTransactionsUrl,
  chargerIdUrl,
  priceGroupsUrl,
  priceGroupIdUrl,
  teamUrlId,
  teamUsersUrl,
  getUserDetailUrl,
  usersUrl,
  getUserProfile,
  rolesUrl,
  chargerTransactions,
  tagTransactions,
  companyUrl,
  getRoleUrlId,
  getRoleUsersUrl,
  getRoleAssignedCompaniesUrl,
  roleCompaniesUrl,
  getUserRoleUrl,
  featureUrl,
  getCompanyUrlId,
  getCompanyPublishedChargersUrl,
  viewLogsUrl,
  getConnectorsUrl,
  getTagsByChargerIdUrl,
  customerUrl,
  getCustomerById,
  customerTagsById,
  tagChargerUrl,
  chargerActiveTransactions,
  tagUserUrl,
  serviceRequestUrl,
  getServiceRequestDetailsUrl,
  chargingProfileListUrl,
  chargingProfileDetailsUrl,
  refundUrl,
  getSettlementPercentageUrl,
  getPaymentDetailsForPriceGroupUrl,
  getPaymentDetailsOfCompany,
  cmCustomerUrl,
  availablePaymentGatewayListUrl,
  paymentGatewayDetailsUrl,
  paymentGatewayMasterListUrl,
  paymentGatewayDetailByIdUrl,
  paymentGatewayTransactionsUrl,
  auditLogsUrl,
  auditAnalyticsUrl,
  auditApiBreakdownUrl,
  walletHistoryUrl,
  teamPayoutUrl,
  getVehicles,
  getAvailableVehicles,
  getAttachedVehicleToCustomer,
  getChargingSiteList,
  getChargingSiteZoneNames,
  getTeamPayout,
  upiTransactionsUrl,
  refundDetailsUrl,
  getVehicleChargingHistory,
  getVehicleEnergySummary,
  apiKeysUrl,
} from "./endPoints";

export const queryKeys = {
  //   authenticate: (chargerId) => {
  //     return ["charger", { method: "GET", url: chargerUrl(chargerId) }];
  //   },
  user: () => ["user", { url: userUrl }],
  users: () => ["users", { url: usersUrl }],
  roles: () => ["roles", { url: rolesUrl }],
  role: (teamId, id) => ["getRole", { url: getRoleUrlId(id) }],
  roleUsers: (teamId, id) => ["roleUsers", { url: getRoleUsersUrl(id) }],
  roleCompanies: () => ["roleCompanies", { url: roleCompaniesUrl }],
  roleAssignedCompanies: (teamId, id) => ["roleAssignedCompanies", { url: getRoleAssignedCompaniesUrl(id) }],
  userRole: (teamId, id) => ["userRole", { url: getUserRoleUrl(id) }],
  usersByTeam: (_, id) => [
    "usersByTeam",
    { url: getTeamUrl(id, teamUsersUrl) },
  ],
  settlementPercentage: [
    "getSettlementPercentage",
    { url: getSettlementPercentageUrl },
  ],
  paymentDetailsForPriceGroup: (teamId) => [
    "getPaymentDetailsForPriceGroup",
    { url: getPaymentDetailsForPriceGroupUrl(teamId) },
  ],
  paymentDetailsOfCompany: (companyId) => [
    "getPaymentDetailsOfCompany",
    { url: getPaymentDetailsOfCompany(companyId) },
  ],
  setupCatgegory: (body) => ["setupCatgegory", { url: categoryUrl, body }],
  setupUserType: (body) => ["setupUserType", { url: userTypeUrl, body }],
  chargers: (teamId, params = { limit: 500 }) => {
    let url = getTeamUrl(teamId, chargersUrl);
    const queryParts = [];
    if (params?.limit) queryParts.push(`limit=${params.limit}`);
    if (params?.page)  queryParts.push(`page=${params.page}`);
    if (queryParts.length) url += `?${queryParts.join("&")}`;
    return ["getChargers", { url }];
  },
  charger: (teamId, chargerId) => [
    "getCharger",
    { url: getTeamUrl(teamId, chargerIdUrl(chargerId)) },
  ],
  generateQR: (teamId, chargerId) => [
    "generateQR",
    { url: getTeamUrl(teamId, `/charger/${chargerId}/generateQr`) },
  ],
  transactions: (teamId, params) => {
    let url = getTeamUrl(teamId, transactionsUrl);

    const queryParts = [];

    if (params) {
      if (params.page && params.limit) {
        queryParts.push(`page=${params.page}`, `limit=${params.limit}`);
      }

      if (params.filters) {
        // Backend expects filters as a JSON string in the "filters" query param
        const encodedFilters =
          typeof params.filters === "string"
            ? encodeURIComponent(params.filters)
            : encodeURIComponent(JSON.stringify(params.filters));
        queryParts.push(`filters=${encodedFilters}`);
      }

      if (params.search) {
        queryParts.push(`search=${encodeURIComponent(params.search)}`);
      }

      if (params.sort) {
        queryParts.push(`sort=${encodeURIComponent(params.sort)}`);
      }

      if (params.order) {
        queryParts.push(`order=${encodeURIComponent(params.order)}`);
      }

      // Server-side date-range restriction (Transactions tab). dateRange is one of
      // last7days/last30days/last60days/last90days/custom; custom also sends from/to.
      if (params.dateRange) {
        queryParts.push(`dateRange=${encodeURIComponent(params.dateRange)}`);
      }
      if (params.from) {
        queryParts.push(`from=${encodeURIComponent(params.from)}`);
      }
      if (params.to) {
        queryParts.push(`to=${encodeURIComponent(params.to)}`);
      }
    }

    if (queryParts.length) {
      url += `?${queryParts.join("&")}`;
    }

    return ["getTransactions", { url }];
  },
  transactionStatus: (teamId, transactionId) => [
    "transactionStatus",
    { url: getTeamUrl(teamId, `/${transactionIdUrl(transactionId)}/status`) },
  ],
  chargerTransactions: (teamId, chargerId) => [
    "getTransactions",
    { url: getTeamUrl(teamId, chargerTransactions(chargerId)) },
  ],
  chargerActiveTransactions: (teamId, chargerId) => [
    "getActiveTransactions",
    { url: getTeamUrl(teamId, chargerActiveTransactions(chargerId)) },
  ],
  tagTransactions: (teamId, tagId) => [
    "getTransactions",
    { url: getTeamUrl(teamId, tagTransactions(tagId)) },
  ],
  payoutTransactions: (teamId, payoutId) => [
    "getTransactions",
    { url: getTeamUrl(teamId, `${transactionsUrl}?payoutId=${payoutId}`) },
  ],
  customerTransactions: (teamId, { id, email, phone, domain, ocpp_tag_pk }) => [
    "getTransactions",
    {
      url: getTeamUrl(
        teamId,
        `${transactionsUrl}?id=${id}&email=${email}&phone=${phone}&domain=${domain}&ocpp_tag_pk=${ocpp_tag_pk}`
      ),
    },
  ],
  transaction: (teamId, transactionId) => [
    "getTransaction",
    { url: getTeamUrl(teamId, transactionIdUrl(transactionId)) },
  ],
  transactionMeterValue: (teamId, transactionId, connectorId) => [
    "getMeterValue",
    {
      url: getTeamUrl(
        teamId,
        meterValueUrl(transactionIdUrl(transactionId), connectorId)
      ),
    },
  ],
  serviceRequest: () => ["getServiceRequests", { url: serviceRequestUrl }],
  serviceRequestDetails: (id) => [
    "getServiceRequestDetails",
    { url: getServiceRequestDetailsUrl(id) },
  ],
  chargingProfileList: () => [
    "getChargingProfileList",
    { url: chargingProfileListUrl() },
  ],
  chargingProfileDetails: (chargingProfileId) => [
    "getChargingProfileDetails",
    { url: chargingProfileDetailsUrl(chargingProfileId) },
  ],
  refund: (teamId, tId = 0) => [
    "refund",
    { url: `${refundUrl}${tId ? "/" + tId : ""}` },
  ],
  tags: (teamId) => ["getTags", { url: getTeamUrl(teamId, tagsUrl) }],
  parentTags: (teamId) => [
    "getParentTags",
    { url: getTeamUrl(teamId, parentTagsUrl) },
  ],
  tagRollup: (teamId, tagId) => [
    "getTagRollup",
    { url: getTeamUrl(teamId, tagRollupUrl(tagId)) },
  ],
  tagChildren: (teamId, tagId) => [
    "getTagChildren",
    { url: getTeamUrl(teamId, tagChildrenUrl(tagId)) },
  ],
  tagParentTransactions: (teamId, tagId) => [
    "getTagParentTransactions",
    { url: getTeamUrl(teamId, tagParentTransactionsUrl(tagId)) },
  ],
  tagsForRemoteOp: (teamId, chargerPk, mail) => [
    "getTagsForRemoteOp",
    {
      url: getTeamUrl(teamId, tagsForRemoteOpUrl, chargerPk),
      method: "POST",
      body: { email: mail },
    },
  ],
  availableTags: (teamId, customerId) => [
    "availableTags",
    { url: getTeamUrl(teamId, availableTagsUrl, customerId) },
  ],
  tag: (teamId, tagId) => [
    "getTag",
    { url: getTeamUrl(teamId, tagIdUrl(tagId)) },
  ],
  tagsCharger: (teamId, tagId, chargerId = null) => [
    "getTagCharger",
    { url: getTeamUrl(teamId, tagChargerUrl(tagId, chargerId)) },
  ],
  tagsUser: (teamId, tagId) => [
    "getTagUser",
    { url: tagUserUrl(teamId, tagId) },
  ],
  priceGroups: (teamId) => [
    "getPriceGroup",
    { url: getTeamUrl(teamId, priceGroupsUrl) },
  ],
  priceGroup: (teamId, priceGroupId) => [
    "getPriceGroup",
    { url: getTeamUrl(teamId, priceGroupIdUrl(priceGroupId)) },
  ],
  chargingSites: (teamId) => [
    "getChargingSites",
    { url: getChargingSiteList(teamId) },
  ],
  chargingSiteZoneNames: (teamId) => [
    "getChargingSiteZoneNames",
    { url: getChargingSiteZoneNames(teamId) },
  ],
  teams: (parentTeamId) => ["getTeams", { url: teamsUrl(parentTeamId) }],

  team: (id) => ["getTeam", { url: teamUrlId(id) }],
  userDetail: (teamId, id) => ["getUser", { url: getUserDetailUrl(id) }],
  profile: () => ["getProfile", { url: getUserProfile() }],
  companyList: () => ["companyList", { url: companyUrl }],
  company: (teamId, id) => ["getCompany", { url: getCompanyUrlId(id) }],
  companyPublishedChargers: (teamId, id) => [
    "getCompanyPublishedChargers",
    { url: getCompanyPublishedChargersUrl(id) },
  ],
  features: () => ["getFeatures", { url: featureUrl }],
  viewLogs: (teamId, chargerId) => [
    "viewLogs",
    { url: getTeamUrl(teamId, viewLogsUrl(chargerId)) },
  ],
  getConnectorsUrl: (teamId, chargerId) => [
    "getConnectorsUrl",
    { url: getTeamUrl(teamId, getConnectorsUrl(chargerId)) },
  ],
  getTagsByChargerId: (teamId, chargerId) => [
    "getTagsByChargerId",
    { url: getTeamUrl(teamId, getTagsByChargerIdUrl(chargerId)) },
  ],
  customers: (_teamId, params = { limit: 500 }) => {
    let url = customerUrl;
    const queryParts = [];
    if (params?.limit) queryParts.push(`limit=${params.limit}`);
    if (params?.page)  queryParts.push(`page=${params.page}`);
    if (queryParts.length) url += `?${queryParts.join("&")}`;
    return ["customerList", { url }];
  },
  customer: (t, id) => ["customer", { url: getCustomerById(id) }],
  customerTags: (t, id) => ["customerTags", { url: customerTagsById(id) }],
  cmCustomers: () => ["cmCustomerList", { url: cmCustomerUrl }],
  cmCustomerById: (id) => [
    "cmCustomerById",
    { url: cmCustomerUrl + `?customerId=${id}` },
  ],

  getPaymentGateway: () => [
    "getPaymentGateway",
    {
      url: availablePaymentGatewayListUrl,
      method: "GET",
    },
  ],
  paymentGatewayDetails: () => [
    "paymentGatewayDetails",
    { url: paymentGatewayDetailsUrl, method: "GET", body: { limit: 1000 } },
  ],
  paymentGatewayMasterList: () => [
    "paymentGatewayMasterList",
    { url: paymentGatewayMasterListUrl, method: "GET" },
  ],
  paymentGatewayDetail: (id) => [
    "paymentGatewayDetail",
    { url: paymentGatewayDetailByIdUrl(id), method: "GET" },
  ],
  paymentGatewayTransactions: (id, params) => [
    "paymentGatewayTransactions",
    { url: paymentGatewayTransactionsUrl(id), method: "GET", body: params },
  ],
  auditLogs: (params) => [
    "auditLogs",
    { url: auditLogsUrl, method: "GET", body: params },
  ],
  auditAnalytics: (params) => [
    "auditAnalytics",
    { url: auditAnalyticsUrl, method: "GET", body: params },
  ],
  auditApiBreakdown: (params) => [
    "auditApiBreakdown",
    { url: auditApiBreakdownUrl, method: "GET", body: params },
  ],
  walletHistoryList: (customerId) => [
    "",
    { url: walletHistoryUrl(customerId), method: "GET" },
  ],
  payoutList: (teamId) => ["", { url: teamPayoutUrl(teamId), method: "GET" }],

  teamPayout: (teamId, year, month) => [
    "teamPayout",
    {
      url: getTeamPayout(teamId, year, month),
      method: "GET",
    },
  ],

  vehicleAssignment: (id) => ["vehicleAssignment", id],
  vehicles: (id) => ["vehicles", { url: getVehicles(id) }],
  availableVehicles: (companyId) => [
    "availableVehicles",
    { url: getAvailableVehicles(companyId) },
  ],
  customerVehicle: (companyId, customerId) => [
    "customerVehicle",
    { url: getAttachedVehicleToCustomer(customerId) },
  ],

  vehicle: (userId, vehicleId) => [
    "vehicle",
    { url: `/customer/${userId}/vehicles/${vehicleId}` },
  ],
  upiTransactions: (teamId, dateRange = "today", params) => {
    let url = upiTransactionsUrl(teamId, dateRange);
    if (params && params.page && params.limit) {
      url += `&page=${params.page}&limit=${params.limit}`;
    }
    return ["getUpiTransactions", { url }];
  },
  refundDetails: (teamId, paymentId) => [
    "getRefundDetails",
    { url: refundDetailsUrl(teamId, paymentId) },
  ],
  vehicleChargingHistory: (vin) => [
    "vehicleChargingHistory",
    { url: getVehicleChargingHistory(vin) },
  ],
  vehicleEnergySummary: (vin) => [
    "vehicleEnergySummary",
    { url: getVehicleEnergySummary(vin) },
  ],
  apiKeys: () => ["apiKeys", { url: apiKeysUrl }],
};
